import { CSSResultGroup, html, TemplateResult } from 'lit';

import { customElement, property } from 'lit/decorators.js';

import componentStyles from './idb-percentage-bar.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';

interface detailData {
  value: number;
  label: string;
}

/**
 * The IDB percentage bar component.
 * @element idb-percentage-bar
 */
@customElement('idb-percentage-bar')
export class IdbPercentageBar extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: Boolean, attribute: 'overlap' })
  overlap: Boolean = false;

  @property({ type: Boolean, attribute: 'two-rows' })
  twoRows: Boolean = false;

  @property({ type: Boolean, attribute: 'with-shadow' })
  withShadow: Boolean = false;

  @property({ type: String, attribute: 'name' })
  name: string = '';

  @property({ type: String, attribute: 'value' })
  value: string = '0%';

  @property({ type: String, attribute: 'description' })
  description: string = '';

  @property({ type: Array, attribute: 'detail' })
  detail: detailData[] = [];

  @property({ type: String, attribute: 'progress-value' })
  progressValue: string = '';

  @property({ type: Boolean, attribute: 'show-progress' })
  showProgress: Boolean = false;

  render(): TemplateResult {
    return html`
      <section class="bar-container">
        ${this.overlap || this.twoRows ? this.descriptionTemplate() : null}
        <div class="graph-bar" style="width:${this.value}%"></div>
        <div class="graph-data" style="width:${this.graphDataWidth()}">
          <div class="graph-label">${this.name}</div>
          <div class="graph-value">${
            this.progressValue ? this.progressValue : this.value + '%'
          }</div>
          ${
            this.detail
              ? html`<div class="graph-detail" style="left:${Math.min(parseFloat(this.value),80)}%">
              <ul>
                ${this.detail.map(item => {
                  return html`<li><span>${item.label}: ${item.value}<div class="icon"></div></span></li>`;
                })}
              </ul>
            </div>`
              : ``
          }
        </div>
        ${this.showProgress ? this.dataProgress() : null}
      </section>
    `;
  }

  descriptionTemplate(): TemplateResult {
    return html`
      <div class="graph-description">
        <p class="m-0">${this.description}</p>
      </div>
    `;
  }

  graphDataWidth(): String {
    return this.withShadow ? '100%' : this.value + '%';
  }

  dataProgress(): TemplateResult {
    return html`
      <div class="graph-progress">
        <ul>
          <li><span>0%</span></li>
          <li><span>20%</span></li>
          <li><span>40%</span></li>
          <li><span>60%</span></li>
          <li><span>80%</span></li>
          <li><span>100%</span></li>
        </ul>
      </div>
    `;
  }
}
